// Zentrale z-index-Leiter des Fenster-/Overlay-Systems. Höher = weiter vorn.
// Referenz der bestehenden Ebenen (nicht alle hier verdrahtet — Doku-Zweck):
//   Fenster untereinander ........... ab 100 (WindowManager nextZ)
//   Fenster-Layer ................... 9000  (WindowLayer)
//   Dock / WindowTaskbar ............ 99999
//   Popover „über Fenstern" ......... 100000 (Konvention)
//   CallWidget (callw-root) / Callbar  1000000
//   Schnellwahl-Backdrop (.sw-backdrop) 1000001
//   Melde-Dialog-Scrim (.tk-scrim, s. tickets.css) .. 1000050
//     — bewusst über dem CallWidget (sonst deckt das Widget die Dialog-
//     Fußleiste ab), aber unter den Ticket-Screenshot-Overlays (1000100)
// Der Window-Confirm-Dialog liegt bewusst ÜBER allem.
export const Z_LAYERS = {
  /**
   * Overlays, die aus einem Fenster heraus geöffnet werden und nach
   * `document.body` portalieren (Modals, Popover). Sie müssen den
   * Fenster-Layer (9000) überbieten, sonst malt die opake Fenster-Karte
   * darüber und das Overlay ist unsichtbar/nicht klickbar. Zwischen `body`
   * und dem Fenster-Layer liegt kein Stacking-Context, die Werte konkurrieren
   * also direkt. Entspricht der oben notierten Konvention „über Fenstern".
   */
  ueberFenster: 100_000,
  /**
   * Unsichtbares Blatt, das NUR während Ziehen/Größe-Ändern eines Fensters
   * über der Seite liegt. Es muss ALLES überdecken, was die Maus sonst
   * abfangen könnte — insbesondere das Mail-Body-`<iframe>`: wandert der
   * Cursor beim Ziehen darüber, gehen `mousemove`/`mouseup` an das Dokument
   * IM iframe, und der Drag bleibt stehen (das Fenster „klebt" fest).
   * Deshalb über Callbar/Schnellwahl (1.000.001), aber unter dem
   * Bestätigungsdialog.
   */
  ziehOverlay: 1_500_000,
  /** Verwerfen/Minimieren-Bestätigung — oberste Ebene, über Callbar. */
  windowConfirm: 2_000_000,
} as const;
